jQuery(document).ready(function($) {

	const $body = $('body');
	const $window = $(window);
	const $document = $(document);
	
	smoothScroll($);
	hamburgerToggle($, $body);
	pageIsScrolled($, $body, $window, $document);
	
	// launch AOS at first scroll tick
	var aosinit = false;
	if(!aosinit){
		AOS.init({
			offset: 0,
			duration: 1000
		});
		aosinit = true;
	}

	/*
	var $item_with_submenu = $('li.menu-item-has-children');

	var resizeItem = function(e){
		var $current = $(this);
		$sizeCurrent = $current.width();
		var $sizeMenu = 0;
		$current.find('li a').each(function(){
			var $itemWidth = $(this).outerWidth();
			if($itemWidth > $sizeCurrent && $itemWidth > $sizeMenu){
				$sizeMenu = $itemWidth;
			}
		});
		if($sizeMenu > 0){
			$current.animate({
				width: $sizeMenu * 1.2,
			  }, 200 ).addClass('hover');
		}else{
			$current.animate({
				width: ($current.outerWidth() * 1.2),
			  }, 200 ).addClass('hover');
		}
	}
	var resetItem = function (e){
		var $current = $(this);		
		$current.css("width", "auto").removeClass('hover');
	}
	
	$item_with_submenu	.on('mouseenter', resizeItem)
						.on('mouseleave', resetItem);

	*/

	var resizeItem = function(){
		$('li.menu-item-has-children').each(function(){
			var $current = $(this);
			$sizeCurrent = $current.width();
			var $sizeMenu = 0;
			$current.find('li a').each(function(){
				var $itemWidth = $(this).outerWidth();
				if($itemWidth > $sizeCurrent && $itemWidth > $sizeMenu){
					$sizeMenu = $itemWidth;
				}
			});
			if($sizeMenu > 0){
				$current.addClass('bigsub');
			}
		});
	}

	resizeItem();

});

jQuery(window).on("load", function(e) {
	jQuery("body").removeClass("preload");
});

function pageIsScrolled($, $body, $window, $document) {

	scrollClasses();
 
	$window.on( 'scroll', function() {
		scrollClasses();
	});

	function scrollClasses() {		
		var $spacer = µSpacer(2.5);
		$body.toggleClass('scrolled', $document.scrollTop() > $spacer);		
	}

}

function hamburgerToggle($, $body) {

	const $hamburgerIcon = $('.hamburger-toggle');
	$hamburgerIcon.on("click", function(e) {
		$body.toggleClass('primary-menu-active');
	});

}

function µSpacer(factor = 1) {
	let spacer = 32;
	if ( 'CSS' in window && CSS.supports && CSS.supports('(--foo: red)' ) ) {
		spacer = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--spacer-current').slice(0,-2));
	}
	return spacer * factor;
}

function smoothScroll($) {

	$('a[href*=\\#]:not([href=\\#])').click(function(e) {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-(µSpacer(2))
				}, 800);
				e.preventDefault();
			}
		}				
	}); 

}

function sendAjax(postData, $form, $errorNotice, callback) {

	$errorNotice.addClass('hidden');

	const $requiredNotice = $form.find('input[required]');
	let error = false;

	$requiredNotice.each(function(){
		if(!jQuery(this).val().length){
			jQuery(this).addClass("required");
			error = true;
			return;
		}
	});

	if (error) return;

	jQuery.ajax({
		url: localizedData.adminAjaxUrl,
		type: "POST",
		cache: false,
		data: postData,
		success: function(res) {

			if (callback) callback(res, postData);

			if (res.success != true) {
				console.log(res);
			}
			
		}
	});

}